import React from "react";
import { useTranslation } from "react-i18next";

import MessageBox from "../../../../components/MessageBox";
import ModalContainer from "../../../../components/ModalContainer";
import Button from "../../../../components/Button";
import InputWithIcon from "../../../../components/InputWithIcon";

// Util
import { messageKeyPrefix } from "../../../../utils/message.util";


const DeletAccount = (props) => {
  const { t } = useTranslation();
  const {
    isOpenDeleteAccountModal,
    setOpenDeleteAccountModal,
    deleteUserMessages,
    setDeleteUserMessages,
    MyProfileStoreCtrl,
    deleteAccount
  } = props;

  return (
    <ModalContainer
      modalWidthType='modal-500px'
      openModal={isOpenDeleteAccountModal}
      closeModal={() => setOpenDeleteAccountModal(false)}
    >
      <div className='header'>
        <div className='title'>{t('516b10a278')}</div>
      </div>
      <div className='body'>
        <MessageBox
          show={!!deleteUserMessages}
          label={t(`${messageKeyPrefix.e.s}${deleteUserMessages}`)}
          variant="danger"
          onClose={() => setDeleteUserMessages(null)}
        />
        <div className='mb-3 modal-warning-color'>{t('792a9e3831')}</div>
        <div className="modal-form-group">
          <div className='modal-form-title required me-3'>{t('dc647eb65e')}</div>
          <div className='modal-form-field'>
            {MyProfileStoreCtrl.state.deletePassword.isText && (
              <InputWithIcon
                type="password"
                placeholder={t('dc647eb65e')}
                autoComplete="delete-account-password"
                value={MyProfileStoreCtrl.state.deletePassword.value}
                onChange={(e) => MyProfileStoreCtrl.changeDeletePassword(e.target.value)}
                isInvalid={MyProfileStoreCtrl.checkPasswordIsValid('deletePassword')}
                iconTitle="Show password"
                iconClassName="icon-open-eye"
                iconOnClick={() => MyProfileStoreCtrl.toggleDeletePasswordEye()}
              />
            )}
            {!MyProfileStoreCtrl.state.deletePassword.isText && (
              <InputWithIcon
                type="text"
                placeholder={t('dc647eb65e')}
                autoComplete="delete-account-password"
                value={MyProfileStoreCtrl.state.deletePassword.value}
                onChange={(e) => MyProfileStoreCtrl.changeDeletePassword(e.target.value)}
                isInvalid={MyProfileStoreCtrl.checkPasswordIsValid('deletePassword')}
                iconTitle="Hide password"
                iconClassName="icon-close-eye"
                iconOnClick={() => MyProfileStoreCtrl.toggleDeletePasswordEye()}
              />
            )}
          </div>
        </div>
      </div>
      <div className='footer'>
        <Button
          label={t('ea4788705e')}
          className='btn-cancel'
          onClick={() => setOpenDeleteAccountModal(false)}
        />
        <Button
          label={t('93cba07454')}
          className='btn-delete'
          disabled={!MyProfileStoreCtrl.state.deletePassword.isValid}
          onClick={() => deleteAccount(MyProfileStoreCtrl.state.deletePassword.value)}
        />
      </div>
    </ModalContainer>
  )
}

export default React.memo(DeletAccount);